<template>
  <div>
    <ul
      class="list-unstyled d-flex justify-content-between mode-filter pt-3"
      v-if="surveyData"
    >
      <li
        v-for="item in surveyData.modePersonaCountList"
        class="mode-filter-item py-1 px-4 mx-1 text-center cursor-pointer d-flex justify-content-between"
        :class="'mode-' + item.type + '-border'"
        :key="'filter-persona-' + item.type"
        :style="{
          width: percentage(item.count, surveyData.total) + '%',
        }"
      >
        <span class="me-3">{{ item.type }} </span>
        <span v-if="fromPage != 'comments'"
          >{{ percentage(item.count, surveyData.total) }}%</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PersonasFilter",
  props: {
    fromPage: {
      type: String,
    },
  },
  computed: {
    surveyData() {
      return this.$store.getters["mainStats/getSurveyWithPersonasById"];
    },
  },
};
</script>

<style lang="scss" scoped>
.mode-filter-item {
  border-radius: $radius-20;
  border: 1px solid;
  min-width: fit-content;
}

.mode-madny-border {
  border-color: $color-madny;
}

.mode-sleepy-border {
  border-color: $color-sleepy;
}
.mode-normaly-border {
  border-color: $color-normaly;
}
.mode-fany-border {
  border-color: $color-fany;
}
.mode-maxi-border {
  border-color: $color-maxi;
}
</style>
